export default {"src":"/_next/static/image/public/images/icons4/6.3908510122113c52e2497390599cd0aa.svg","height":42,"width":42};